/* eslint-disable import/prefer-default-export */

import { createSelector } from 'reselect';

const getPhaseRevenueSelector = phase => ({
  revenue: phase.revenue,
  expenses: phase.expenses,
});

export const getPhaseMarginProfit =
  createSelector(
    getPhaseRevenueSelector,
    ({ revenue, expenses }) => ({
      profit: revenue - expenses,
      margin: revenue > 0 ? (100 * ((revenue - expenses) / revenue)) : 0,
    }),
  );



// WEBPACK FOOTER //
// ./client/app/selectors/phase.js